import React from "react";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Alert, Stack, TextField } from "@mui/material";
import Cookies from 'universal-cookie';
import LoadingButton from "@mui/lab/LoadingButton";
import _default from "../themes/default";
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import sendMailConfermaData from "../services/sendMailConfermaData";

const cookies = new Cookies();
var token = cookies.get('token', { path: '/' });
var username = cookies.get('username', { path: '/' });
let current = cookies.get('ordine', { path: '/' });

const style = {
    zIndex: 999,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'white',
    borderRadius: 2,
    border: '0',
    boxShadow: 24,
    p: 4,
};

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
    width: 62,
    height: 34,
    padding: 7,
    '& .MuiSwitch-switchBase': {
        margin: 1,
        padding: 0,
        transform: 'translateX(6px)',
        '&.Mui-checked': {
            color: '#fff',
            transform: 'translateX(22px)',
            '& .MuiSwitch-thumb:before': {
                backgroundImage: `url('data:image/svg+xml;utf8,<svg fill="${encodeURIComponent('#fff')}" width="16pc" height="16px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24"><path d="M17,9V7c0-2.8-2.2-5-5-5S7,4.2,7,7v2c-1.7,0-3,1.3-3,3v7c0,1.7,1.3,3,3,3h10c1.7,0,3-1.3,3-3v-7C20,10.3,18.7,9,17,9z M9,7c0-1.7,1.3-3,3-3s3,1.3,3,3v2H9V7z"/></svg>')`,
            },
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: '#5cb500'
            },
        },
    },
    '& .MuiSwitch-thumb': {
        backgroundColor: '#5cb500',
        width: 32,
        height: 32,
        '&:before': {
            content: "''",
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 580 580" width="16" height="16" fill="${encodeURIComponent('#fff')}"><path d="M352 192H384C419.3 192 448 220.7 448 256V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V256C0 220.7 28.65 192 64 192H288V144C288 64.47 352.5 0 432 0C511.5 0 576 64.47 576 144V192C576 209.7 561.7 224 544 224C526.3 224 512 209.7 512 192V144C512 99.82 476.2 64 432 64C387.8 64 352 99.82 352 144V192z"/></svg>')`,
        },
    },
    '& .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
        borderRadius: 20 / 2,
    },
}));

export default class MyModalMailConfermaData extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            emailLocked: true,
            email: '',
            ragione_sociale: '',
        }
    }

    async send() {
        sendMailConfermaData(username, token, this.state.email, this.state.ragione_sociale, current).then(async res => {
            if (res.result === 'ok') {
                window.location.href = '/#/service/ordini';
            } else {
                this.props.handleError();
            }
        })
    }

    async close() {
        this.props.onClose();
    }

    async componentDidMount() {
        if (this.props.modal.show) {
            this.setState({ email: this.props.modal.email, ragione_sociale: this.props.modal.ragione_sociale });
        }
    }

    render() {
        return (
            <Modal
                open={this.props.modal.show}
                onClose={() => this.close()}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Stack direction={"column"} spacing={2} sx={{ flex: 1 }}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            {this.props.title}
                        </Typography>
                        {this.state.error && <Alert severity="error" sx={{ marginTop: 2, marginBottom: 5 }}>Impossibile inviare il messaggio al momento</Alert>}
                        <Stack direction={'row'} spacing={2} sx={{ flex: 1 }} >
                            <TextField fullWidth inputProps={{ readOnly: this.state.emailLocked }} value={this.state.email} label="Email" variant="outlined" InputLabelProps={{ shrink: this.state.email }} onChange={(e) => this.setState({ email: e.target.value.trim() })} />
                            <FormGroup>
                                <FormControlLabel
                                    control={<MaterialUISwitch sx={{ m: 1 }}
                                        checked={this.state.emailLocked}
                                        onChange={() => this.setState({ emailLocked: !this.state.emailLocked })} />}
                                />
                            </FormGroup>
                        </Stack>
                        <Stack direction={'row'} spacing={2} sx={{ flex: 1 }}>
                            <LoadingButton fullWidth sx={{ flex: 1, minHeight: 50 }} style={{ backgroundColor: _default.palette.primary.main }} variant='contained' loading={this.state.isLoading} onClick={
                                () => this.send()
                            }>Invia Email</LoadingButton>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
        )
    }
}